var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handler--basic-fields-list"},[_vm._l((_vm.inputs),function(input){
var _obj;
return _c('div',{key:input.id,staticClass:"handler--basic-fields-list__input position--relative"},[_c('dynamic-fields',{staticClass:"contact__dynamic",attrs:{"obj":( _obj = {}, _obj[input.label.name] = input.label.value, _obj[input.value.name] = input.value.value, _obj ),"isEdition":_vm.isEdition,"allowFilling":_vm.allowFilling,"translations":_vm.translations}}),(_vm.inputs.length > 1)?_c('button-with-icon',{staticClass:"handler--basic-fields-list__button--delete position--absolute",attrs:{"icon":{
                component: function () { return import(
                    /* webpackChunkName: 'IconTrash' */ '@/components/bundles/layout/images/icons/IconTrash'
                ); }
            },"aria-label":_vm.$t('accessibility.delete'),"action":{
                execute: true,
                function: _vm.actions.delete(),
                param: input.id
            }}}):_vm._e()],1)}),_c('button-with-icon',{staticClass:"handler--basic-fields-list__button--add",attrs:{"icon":{
            component: function () { return import( /* webpackChunkName: 'IconPlus' */ '@/components/bundles/layout/images/icons/IconPlus' ); }
        },"aria-label":_vm.$t('accessibility.addProp', { prop: _vm.$t('accessibility.field') }),"action":{
            execute: true,
            function: _vm.actions.add()
        }}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }